import { render, staticRenderFns } from "./editAffiliateRelation.vue?vue&type=template&id=13d23972"
import script from "./editAffiliateRelation.vue?vue&type=script&lang=js"
export * from "./editAffiliateRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports